<script setup>
import { computed } from 'vue';
import { splitClass } from '@/utils/format';

// One class in a weekly schedule table: the subject in the brand colour so
// it reads apart from its section. The default slot adds controls after the
// text, e.g. a remove button.
const props = defineProps({
  value: { type: String, default: '' },
});
const parts = computed(() => splitClass(props.value));
</script>

<template>
  <span v-if="parts.subject" class="schedule-cell">
    <span>
      <span class="schedule-cell__subject">{{ parts.subject }}</span
      ><template v-if="parts.section">, {{ parts.section }}</template>
    </span>
    <slot />
  </span>
</template>

<style scoped>
.schedule-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.schedule-cell__subject {
  font-weight: 600;
  color: var(--brand);
}
</style>
